module.exports = __webpack_public_path__ + "img/iso.9dd6434e.svg";